import { useObjectContext } from '@components/v2/layout/ObjectScreen/hooks/useObjectContext';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import { OrderCondition } from '../../../../../../../conditions/interfaces/orderCondition.interface';
import { isOrderWideConditionError } from '../../../../../../../conditions/orderConditionFieldErrors.utils';
import { useOrderConditionContext } from '../../../../../../../contexts/OrderCondition.context';
import { ALL_ORDER_CONDITIONS_ID } from '../../../../../../../contexts/hooks/useSelectedOrderCondition';
import { useOrderEditSectionsContext } from '../../../../../../../edit/sections/OrderEditSections.context';
import { ORDER_OBJECT_TAB } from '../../../../../../../orders.constants';

const useOrderObjectSplitsSection = () => {
  const { translate } = useTranslation();
  const { activeTab } = useObjectContext();
  const { orderConditions, selectedConditionId, isAllConditionsSelected, selectCondition } =
    useOrderConditionContext();
  const { rawConditionErrors } = useOrderEditSectionsContext();

  const isConditionsTab = activeTab === ORDER_OBJECT_TAB.CONDITIONS;
  const shouldHighlightFirstCondition = isAllConditionsSelected && isConditionsTab;

  const conditionIdsWithErrors = new Set(
    rawConditionErrors
      .filter(({ errors }) => errors.some((error) => !isOrderWideConditionError(error)))
      .map(({ orderConditionId }) => orderConditionId),
  );

  const sortByErrorFirst = (first: OrderCondition, second: OrderCondition) =>
    Number(conditionIdsWithErrors.has(second.id)) - Number(conditionIdsWithErrors.has(first.id));

  const shouldSortByError = isConditionsTab && conditionIdsWithErrors.size > 0;

  return {
    groupLabel: translate(LangEnum.GLOBAL_ORDER_SPLITS),
    title: `${translate(LangEnum.GLOBAL_ORDER_SPLITS)} (${orderConditions.length})`,
    isConditionsTab,
    isAllConditionsSelected,
    isAllSelected: isAllConditionsSelected && !shouldHighlightFirstCondition,
    highlightedConditionId: shouldHighlightFirstCondition
      ? orderConditions[0]?.id
      : selectedConditionId,
    listedConditions: shouldSortByError
      ? [...orderConditions].sort(sortByErrorFirst)
      : orderConditions,
    hasConditionError: (conditionId: string) =>
      isConditionsTab && conditionIdsWithErrors.has(conditionId),
    selectAllConditions: () => selectCondition(ALL_ORDER_CONDITIONS_ID),
    selectCondition,
  };
};

export default useOrderObjectSplitsSection;
